import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import clsx from "clsx";
import React from "react";
import { Bullet } from "./Bullet";
import { PageContainer } from "./PageContainer";
export function Hero(_param) {
    var heading = _param.heading, subheading = _param.subheading, cta = _param.cta, image = _param.image, _bullet = _param.bullet, bullet = _bullet === void 0 ? "" : _bullet, _fingerprint = _param.fingerprint, fingerprint = _fingerprint === void 0 ? "" : _fingerprint, _animate = _param.animate, animate = _animate === void 0 ? undefined : _animate, rest = _object_without_properties(_param, [
        "heading",
        "subheading",
        "cta",
        "image",
        "bullet",
        "fingerprint",
        "animate"
    ]);
    // useEffect(() => {
    //     console.log('Hero render')
    // })
    return /*#__PURE__*/ _jsx(PageContainer, _object_spread_props(_object_spread({}, rest), {
        children: /*#__PURE__*/ _jsxs("div", {
            className: clsx("flex items-center max-w-full flex-col", "md:flex-row leading-normal", image ? "justify-start md:space-x-8" : "justify-center"),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: clsx("space-y-8 shrink-0 flex max-w-full flex-col text-center", image ? "md:max-w-[70%]" : "w-full", image ? "items-start" : "items-center", image ? "md:text-left" : "text-center"),
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: clsx("flex flex-col w-full items-center space-y-4 ", image ? "md:items-start" : ""),
                            children: [
                                bullet && /*#__PURE__*/ _jsx(Bullet, {
                                    children: bullet
                                }),
                                /*#__PURE__*/ _jsx(ComponentIfString, {
                                    component: "h1",
                                    className: "block even:!mt-2 text-5xl font-semibold leading-normal",
                                    children: heading
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(ComponentIfString, {
                            component: "h2",
                            className: "text-2xl opacity-[0.78] leading-relaxed",
                            children: subheading
                        }),
                        cta && /*#__PURE__*/ _jsxs("div", {
                            className: classNames("flex flex-col items-center max-w-full  w-full space-y-6", image && "md:items-start "),
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "",
                                    children: cta
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "opacity-60 text-xs",
                                    children: fingerprint
                                })
                            ]
                        })
                    ]
                }),
                image && /*#__PURE__*/ _jsxs("div", {
                    className: clsx("flex max-w-full flex-col md:flex-row flex-auto items-center "),
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "ml-[40px] mt-[40px] flex-auto"
                        }),
                        image
                    ]
                })
            ]
        })
    }));
}
function ComponentIfString(_param) {
    var C = _param.component, children = _param.children, rest = _object_without_properties(_param, [
        "component",
        "children"
    ]);
    if (!children) {
        return null;
    }
    if (typeof children === "string") {
        return /*#__PURE__*/ _jsx(C, _object_spread_props(_object_spread({}, rest), {
            children: children
        }));
    }
    return /*#__PURE__*/ _jsxs("span", _object_spread_props(_object_spread({}, rest), {
        children: [
            " ",
            children
        ]
    }));
}
